import { useCallback, useRef } from "react";

/** framer `Reorder` fires a synthetic click on the dragged element when the
 *  pointer is released, which would also trigger the row's onClick (e.g. toggle
 *  the filter). This guard records that a drag happened so the row can swallow
 *  the immediately-following click. One guard per list (only one drag at a time).
 *
 *  Wire `onDragStart`/`onDragEnd` onto each `Reorder.Item`, and early-return from
 *  the row's onClick when `suppressClick()` returns true. */
export function useDragClickGuard() {
  const dragged = useRef(false);
  const onDragStart = useCallback(() => { dragged.current = true; }, []);
  // Fallback reset in case no click follows the release.
  const onDragEnd = useCallback(() => { setTimeout(() => { dragged.current = false; }, 60); }, []);
  const suppressClick = useCallback(() => {
    if (dragged.current) { dragged.current = false; return true; }
    return false;
  }, []);
  return { onDragStart, onDragEnd, suppressClick };
}
